import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import { injectFromApp } from "../../../inject";
import type { IAboutUsDialogStore } from "./AboutUsDialogStore";
import { ModalDialogComponent } from "../../../modal-dialog/ModalDialogComponent";
import { ModalDialogHeaderComponent } from "../../../modal-dialog/elements/ModalDialogHeaderComponent";
import { ModalDialogFooterComponent } from "../../../modal-dialog/elements/ModalDialogFooterComponent";
import { ModalDialogBodyComponent } from "../../../modal-dialog/elements/ModalDialogBodyComponent";
import type { IProductInfoStore } from "../../../product-info/ProductInfoStore";
import type { IUserSessionStore } from "../../../user/UserSessionStore";
import { ThirdPartySoftwareComponent } from "./ThirdPartySoftwareComponent";

interface IAboutUsDialogComponentProps {
    productInfoStore?: IProductInfoStore;
    resourcesStore?: IResourcesStore;
    aboutUsDialogStore?: IAboutUsDialogStore;
    userSessionStore?: IUserSessionStore;
}
@injectFromApp<IAboutUsDialogComponentProps>((stores) => ({
    productInfoStore: stores.productInfoStore,
    resourcesStore: stores.resourcesStore,
    aboutUsDialogStore: stores.aboutUsDialogStore,
    userSessionStore: stores.userSessionStore,
}))

@observer
export class AboutUsDialogComponent extends React.Component<IAboutUsDialogComponentProps> {

    private readonly closeDialog = () => {
        const { aboutUsDialogStore } = this.props;
        aboutUsDialogStore!.setOpen(false);
    };

    render() {
        const { resourcesStore, aboutUsDialogStore, productInfoStore, userSessionStore } = this.props;
        const { resources } = resourcesStore!;
        const { isOpen } = aboutUsDialogStore!;
        const { version, productReleaseDate, manualsRevisionDate, environmentMachineName, softwareIdentificationNumber, isMedicalDevice } = productInfoStore!;
        const { isGlobalAdmin } = userSessionStore!;
        
        return (
            <ModalDialogComponent className="about-us" isOpen={isOpen} onClose={this.closeDialog} closeOnOverlay={false}>
                <ModalDialogHeaderComponent title={resources.About + " DeepUnity PACSonWEB" + (!isMedicalDevice ? " Core" : "") + " - DH Healthcare GmbH"} onClose={this.closeDialog} />
                <ModalDialogBodyComponent>
                    <div>
                        <div className="support">
                            <h2>{resources.Support}</h2>
                            <br />
                            <p dangerouslySetInnerHTML={{ __html: resources.SupportInfoAndLink.replace("{0}", "/POW3/Support") }} />
                            <br />
                            <br />
                            <p>
                                {resources.SupportTechnical}
                                <br />
                                <a href="/POW3/Resource/GetTeamviewer">{resources.ClickHereToStartTeamViewer}</a>
                            </p>
                        </div>
                        <div className="company-information">
                            <h2>{resources.CompanyInformation}</h2>
                            <br />
                            <p>
                                <img src="/POW4/img/icons/icnCompanyInformation.png" alt={resources.CompanyInformation} />
                            </p>
                            <br />
                            <div>
                                <p>DH Healthcare GmbH</p>
                                <p>Konrad-Zuse-Platz 1-3</p>
                                <p>53227 Bonn, Germany</p>
                                {resources.Website}:{" "}
                                <a href={"https://www.dedalusgroup.de/"} target={"_blank"} rel="noreferrer">
                                    www.dedalusgroup.de
                                </a>
                                <p>Copyright (C) 2024</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="software-identification">
                            <h2>{resources.SoftwareIdentification}</h2>
                            <p className={"pacsonweb-version-info"}>
                                DeepUnity PACSonWEB { !isMedicalDevice && "Core" } <b>V{version}</b>
                            </p>
                            { isMedicalDevice && 
                                <div>
                                    <img src="/POW4/img/icons/icnUDI.png" alt={resources.SoftwareIdentification} />
                                    <p>
                                        {softwareIdentificationNumber}
                                        {version}
                                    </p>
                                </div>
                            }
                            <div>
                                <img src="/POW4/img/icons/icnSoftwareIdentification.png" alt={resources.SoftwareIdentification} />
                                <p>
                                    {resources.Released} <b>{productReleaseDate}</b>
                                </p>
                            </div>
                            { isMedicalDevice &&
                                <div>
                                    <img src={"/POW4/img/icons/icnCE2862.png"} alt={"CE2862"} />
                                    <img src={"/POW4/img/icons/icnMD.png"} alt={"MD"} />
                                </div>
                            }
                            <ThirdPartySoftwareComponent />
                        </div>
                        <div className="user-manuals">
                            <h2>{resources.UserManuals}</h2>
                            <p>
                                <img src="/POW4/img/icons/icnUserManuals.png" alt={resources.UserManuals} />
                            </p>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: resources.ManualWarning.replace("{0}", "/POW3/Resource/LocalHelpFile").replace("{1}", "/POW3/Resource/GetManualPDF"),
                                }}
                            />
                            <p>
                                {resources.LastRevision}: <b>{manualsRevisionDate}</b>
                            </p>
                        </div>
                    </div>
                </ModalDialogBodyComponent>
                <ModalDialogFooterComponent>
                    {isGlobalAdmin && (
                        <p className={"environment-machine-name"}>
                            ref: <span>{environmentMachineName}</span>
                        </p>
                    )}
                    <div className={"buttons-container"}>
                        <button className="silent" onClick={this.closeDialog}>
                            {resources.Close}
                        </button>
                    </div>
                </ModalDialogFooterComponent>
            </ModalDialogComponent>
        );
    }
}
